import React from 'react';

const TagWidgets = () => {
    return (
        <>
            <div className="widget-tag">
                <h1>keywoad</h1>
                <ul>
                    <li>
                        <a href="#">Office </a>
                    </li>
                    <li>
                        <a href="#">CCTV</a>
                    </li>
                    <li>
                        <a href="#">Management</a>
                    </li>
                    <li>
                        <a href="#">Service</a>
                    </li>
                    <li>
                        <a href="#">Security</a>
                    </li>
                    <li>
                        <a href="#">Bank</a>
                    </li>
                    <li>
                        <a href="#">Planing</a>
                    </li>
                    <li>
                        <a href="#">House</a>
                    </li>
                    <li>
                        <a href="#">Parking</a>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default TagWidgets;